<template>
  <div class="policy">
    <component :is="getPolicy()" :id="`policy-${language}`" />
  </div>
</template>

<script>
import English from './English.vue'
import Spanish from './Spanish.vue'
import Portuguese from './Portuguese.vue'

export default {
  name: 'PrivacyPolicy',

  components: {
    English,
    Spanish,
    Portuguese,
  },

  methods: {
    getPolicy() {
      switch (this.language) {
        case 'en':
          return 'English'
        case 'es':
          return 'Spanish'
        case 'pt':
          return 'Portuguese'
        default:
          return 'English'
      }
    },
  },
}
</script>

<style lang="scss">
.policy {
  padding: 20px;
  margin: 0 auto;
  max-width: 960px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    color: $main-two;
  }

  ul {
    list-style: circle;

    li {
      margin-left: 32px;
    }
  }

  a {
    color: $blue;
  }

  h1 {
    font-size: rem(28);
  }

  h1 {
    font-size: rem(28);
  }

  p {
    margin: 16px 0;
  }
}
</style>
